module.exports = __webpack_public_path__ + "static/img/icon-good.f352e305.png";